var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("HALLLOOOO ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","pl-4":"","pa-2":""}},[_c('v-text-field',{attrs:{"label":"REFERENCE"},model:{value:(_vm.selectedItem.reference),callback:function ($$v) {_vm.$set(_vm.selectedItem, "reference", $$v)},expression:"selectedItem.reference"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05fc162c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ecommerce/googleAds/GoogleAdwords.vue
// module id = null
// module chunks = 